<template>
    <div class="wrapper-bids-lists">
        <div class="tabs">
            <div class="pb-5 wrapper-filter-button d-flex justify-content-between align-items-baseline">
                <div class="col-2 p-0" v-if="firstList && showFilter">
                    <div v-if="sortProgressBids.length">
                        <button @click="show = !show" class="btn button-text filters-btn filters-btn-desktop js-open-filters">
                            Filter
                        </button>
                        <button @click="show = !show" class="btn button-text filters-btn filters-btn-mobile">
                            Filter
                        </button>
                    </div>
                    <div v-else class="modile-view">
                        <p class="main-text-bold text-muted">Tip: Try change filters options</p>
                        <button type="button" @click="getAllBids()"
                                class="btn-underline btn main-text filters-link text-purple px-0">
                            Clear Filters
                        </button>
                    </div>
                </div>
                <div class="ms-auto">
                    <a class="dropdown-item main-text " href="https://www.info.hedlyner.com/bid-feature">How do events work?</a>
                </div>
                <div id="slider"></div>
            </div>
            <div class="row" v-if="bids.length && show">
                <vue-filters :bids="bids" :url="url" :filterBudget="filterBudget"
                             :isVisbleFilter.sync="show" @filter="triggerFilter($event)"></vue-filters>
            </div>
            <div class="row wrapper-table-title">
                <div class="col-4 col-lg-2 tab-title" v-bind:class="{active: firstList}">
                    <a class="cursor-pointer js-change-tab" @click="selectFirstList()">
                        Search ({{ sortProgressBids.length }})
                    </a>
                </div>
                <div class="col-4 col-lg-3 tab-title" v-if="parseInt(isArtist)" v-bind:class="{active: secondList}">
                    <a class="js-change-tab cursor-pointer" @click="selectSecondList()">
                        Submitted ({{ confirmedBids.length }})
                    </a>
                </div>
                <div class="col-4 tab-title" v-if="parseInt(isArtist)" v-bind:class="{active: thirdList}">
                    <a class="js-change-tab cursor-pointer" @click="selectThirdList()">
                        Booked ({{ bookingBids.length }})
                    </a>
                </div>
            </div>

            <!--First List Search -->
            <div v-if="firstList">
                <div class="accordion accordion-flush" v-if="sortProgressBids.length" id="search-accordion-flash">
                    <AccordionItemBids
                        v-for="(bid, index) in bids" :key="index"
                        :bid="bid"
                        @applyEvent="applyBid"
                    />
                </div>
                <div class="empty-records" v-else>
                    <h3>Your search got no hits.  Try removing some of the filters.</h3>
                </div>
            </div>

            <!--Second table Apply Bid-->
            <div v-else-if="secondList">
                <div class="accordion accordion-flush" v-if="sortconfirmedAndCompletedBids.length" id="confirmed-accordion-flash">
                    <div class="accordion-item" v-for="(bid, index) in sortconfirmedAndCompletedBids" :key="index">
                        <div class="header-artist-accordion row align-items-center">
                            <div class="col-12 col-sm-6 col-xl-3">
                                <p class="big-artist-text mb-0">{{ bid.start_date }}</p>
                                <p class="main-text">Start Date</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2">
                                <p class="big-artist-text mb-0">${{ bid.budget }}</p>
                                <p class="main-text">Payout</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2 word-break">
                                <div class="d-flex wrapper-keywords-pills">
                                    <div class="keywords-pills mb-2" v-for="(keyword, index) in bid.array_keywords"
                                         :key="index">{{ keyword }}
                                    </div>
                                </div>
                                <p class="main-text text-muted mt-2 mb-0">Sound</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2">
                                <p class="big-artist-text mb-1">{{ bid.city_address }}</p>
                                <p class="main-text text-muted">Location</p>
                            </div>
                            <div
                                class="col-12 col-sm-6 col-xl-2 d-flex justify-content-start justify-content-xl-center">
                                <div class="col-4 main-text text-center">
                                    <span class="status-bags">{{ getChildrenStatus(bid.artist_bid) }}</span>
                                </div>
                            </div>
                            <div class="col-6 col-xl-1">
                                <button class="accordion-button collapsed js-open-collapse" type="button"
                                        data-bs-toggle="collapse"
                                        :data-bs-target="'#flush-collapse-' + bid.id">
                                </button>
                            </div>
                        </div>


                        <div :id="'flush-collapse-' + bid.id" class="accordion-collapse collapse"
                             data-bs-parent="#confirmed-accordion-flash">
                            <div class="accordion-body">
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="main-text-bold">Sound Equipment</p>
                                        <p class="main-text">
                                            <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                            <span v-else>Artist mustn't bring own sound equipment</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-8 mt-4">
                                        <p class="main-text-bold">Special Riders/Extras</p>
                                        <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                                    </div>

                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                                        <p class="main-text">Start Time</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                                        <p class="main-text">Duration</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                                        <p class="main-text">Venue Capacity</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-if="parseInt(bid.my_artist_bid.counter_offer) !== parseInt(bid.venue_budget) && parseInt(bid.counter_offer_status) === 0" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Your counter offer</p>
                                        <p class="big-artist-text">${{ bid.my_artist_bid.counter_offer }}</p>
                                    </div>
                                    <div v-if="parseInt(bid.counter_offer_status) === 2" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Venue counter offer</p>
                                        <p class="big-artist-text">${{ bid.my_artist_bid.counter_offer }}</p>
                                    </div>
                                    <div v-if="parseInt(bid.my_artist_bid.counter_offer_duration) !== parseInt(bid.duration) && parseInt(bid.counter_offer_status) === 2" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Venue counter duration</p>
                                        <p class="big-artist-text">{{ bid.counter_offer_duration }}</p>
                                    </div>
                                    <div v-if="bid.my_artist_bid.extra_requirements" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Extra Requirements</p>
                                        <p class="main-text">{{ bid.my_artist_bid.extra_requirements }}</p>
                                    </div>
                                    <div class="row justify-content-end cancel mt-4">
                                        <div class="col-5 text-end">
                                            <button class="btn-apply button-text" @click="rejectedBid(bid)"
                                                    type="button">
                                                Withdraw
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-records" v-else>
                    <h3>You haven't been booked through a bid just yet,
                        but keep applying and we're sure you'll win one soon.</h3>
                </div>
            </div>

            <!--Third List table Booking-->
            <div v-else>
                <div class="accordion accordion-flush" v-if="sortcancelBids.length" id="booking-accordion-flash">
                    <div class="accordion-item" v-for="(bid, index) in sortcancelBids" :key="index">
                        <div class="header-artist-accordion row align-items-center">
                            <div class="col-12 col-sm-6 col-xl-3">
                                <p class="big-artist-text mb-0">{{ bid.start_date }}</p>
                                <p class="main-text">Start Date</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2">
                                <p class="big-artist-text mb-0">${{ bid.budget }}</p>
                                <p class="main-text">Payout</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2 word-break">
                                <div class="d-flex wrapper-keywords-pills">
                                    <div class="keywords-pills mb-2" v-for="(keyword, index) in bid.array_keywords"
                                         :key="index">{{ keyword }}
                                    </div>
                                </div>
                                <p class="main-text text-muted mt-2 mb-0">Sound</p>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-2">
                                <p class="big-artist-text mb-1">{{ bid.city_address }}</p>
                                <p class="main-text text-muted">Location</p>
                            </div>
                            <div
                                class="col-12 col-sm-6 col-xl-2 d-flex justify-content-start justify-content-xl-center">
                                <div class="col-12 main-text text-center">
                                    <span class="status-bags">{{ getStatus(bid.status) }}</span>
                                </div>
                            </div>
                            <div class="col-6 col-xl-1">
                                <button class="accordion-button collapsed js-open-collapse" type="button"
                                        data-bs-toggle="collapse"
                                        :data-bs-target="'#flush-collapse-' + bid.id">
                                </button>
                            </div>
                        </div>


                        <div :id="'flush-collapse-' + bid.id" class="accordion-collapse collapse"
                             data-bs-parent="#booking-accordion-flash">
                            <div class="accordion-body">
                                <div class="row justify-content-end cancel">
                                    <div class="col-5 text-end">
                                        <button class="btn-apply button-text" @click="openBookingPage(bid)"
                                                type="button">
                                            Open Booking
                                        </button>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="main-text-bold">Sound Equipment</p>
                                        <p class="main-text">
                                            <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                            <span v-else>Artist mustn't bring own sound equipment</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-8 mt-4">
                                        <p class="main-text-bold">Special Riders/Extras</p>
                                        <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                                    </div>

                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                                        <p class="main-text">Start Time</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                                        <p class="main-text">Duration</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                                        <p class="main-text">Venue Capacity</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div v-if="parseInt(bid.my_artist_bid.counter_offer) !== parseInt(bid.venue_budget) && parseInt(bid.counter_offer_status) === 0" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Your counter offer</p>
                                        <p class="big-artist-text">${{ bid.my_artist_bid.counter_offer }}</p>
                                    </div>
                                    <div v-if="parseInt(bid.counter_offer_status) === 2" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Venue counter offer</p>
                                        <p class="big-artist-text">${{ bid.my_artist_bid.counter_offer }}</p>
                                    </div>
                                    <div v-if="parseInt(bid.my_artist_bid.counter_offer_duration) !== parseInt(bid.duration) && parseInt(bid.counter_offer_status) === 2" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Venue counter duration</p>
                                        <p class="big-artist-text">{{ bid.counter_offer_duration }}</p>
                                    </div>
                                    <div v-if="bid.my_artist_bid.extra_requirements" class="col-12 col-md-6 col-lg-4">
                                        <p class="main-text-bold">Extra Requirements</p>
                                        <p class="main-text">{{ bid.my_artist_bid.extra_requirements }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-records" v-else>
                    <h3>
                        You haven't been booked through a bid just yet,
                        but keep applying and we're sure you'll win one soon.
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {notification} from "../../helpers/notification";
import axios from "axios";
import Filters from "./filters.vue";
import AccordionItemBids from './AccordionItemBids.vue'

const Swal = require('sweetalert2')

export default {
    name: "index-artist",
    props: {
        isArtist: String
    },
    components: {
        Filters,
        AccordionItemBids
    },
    data() {
        return {
            url: '/events',
            bidUrl: '/event',
            bids: [],
            city_address: '',
            cloneBids: [],
            confirmedBids: [],
            bookingBids: [],
            filterBudget: {
                min: null,
                max: null,
            },
            firstList: true,
            secondList: false,
            thirdList: false,
            extraInfoBid: {
                counter_offer: null,
                extra_requirements: null,
            },
            showAccordion: false,
            show: false,
            showFilter: false
        }
    },
    async mounted() {
        await this.getAllBids()
        await this.getConfirmedBids()
        await this.getBookingBids()
    },
    methods: {
        triggerFilter(bids) {
            this.bids = bids
        },

        async getAllBids() {
            let vm = this;
            const response = await axios.get(vm.url + '/new-and-proceed-list')

                vm.filterBudget.min = response.data.min
                vm.filterBudget.max = response.data.max
                vm.bids = response.data.bids
                vm.cloneBids = response.data.bids

                if (this.bids.length) vm.showFilter = true
        },

        async getConfirmedBids() {
            let vm = this;

            const response = await axios.get(vm.url + '/confirmed-and-completed-list')
            vm.confirmedBids = response.data.data
        },

        async getBookingBids() {
            let vm = this;

            const response = await axios.get(vm.url + '/booking-list')
            vm.bookingBids = response.data.data
        },

        openFilters() {
            $('.filter-wrapper').show()
        },

        rejectedBid(bid) {
            let vm = this;
            Swal.fire({
                title: 'Are you sure?',
                text: "By withdrawing, you won't be able to reapply for this bid.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, withdraw.'
            }).then((result) => {
                if (result.value) {
                    axios.put(vm.bidUrl + '/reject/' + bid.id).then(function (response) {
                        vm.getAllBids()
                        vm.getConfirmedBids()
                        notification('success', 'Bid rejected successfully')
                    }).catch(function (error) {
                        notification('error', error.response.data.message)
                    })
                }
            })
        },

        applyBid(bid, event) {
            let extraInfoBid = JSON.parse(localStorage.getItem('data'))
            let vm = this,
                el = event.target,
                extraPriceBid = extraInfoBid.counter_offer > 0 ? extraInfoBid.counter_offer : bid.budget;
            removeError(el)
            if (extraPriceBid.counter_offer > 0 && extraPriceBid.counter_offer < minimalPrice) {
                addError(el)
            } else {
                Swal.fire({
                    html: vm.htmlApplyBtn(extraPriceBid, bid.start_date),
                    iconHtml: '<img src="/images/icons/info_icon_bid.png" alt="">',
                    customClass: {
                        icon: 'no-border',
                        cancelButton: 'btn-outline-cancel-swall',
                    },
                    width: 615,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Confirm',
                    showCloseButton: true,
                    showCancelButton: true,
                    cancelButtonText: 'Decline',
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.js-preloader').addClass('preloader-div')
                        axios.post(vm.bidUrl + '/apply/' + bid.id, extraInfoBid).then(function (response) {
                            vm.resetExtraInfoBid()
                            vm.getAllBids()
                            vm.getConfirmedBids()
                            $('.js-preloader').removeClass('preloader-div')
                            notification('success', response.data.message);
                        }).catch(function (error) {
                            $('.js-preloader').removeClass('preloader-div')
                            notification('error', error.data.message);
                        })
                    }
                })
            }
        },

        /**
         *  Html Text to pop-up when user click on apply button
         * @param counter_offer
         * @param start_date
         * @returns {string}
         */
        htmlApplyBtn(counter_offer, start_date) {
            return "<div class='apply-desc-modal'>" +
                "By selecting this button," +
                " you agree that if confirmed by" +
                " the Buyer you will be available  " +
                "for a live performance at the shown" +
                " address on <b><u>" + start_date + "</u></b> and will accept" +
                " a total payout of <b><u>$" + counter_offer + "</u></b> for the entire show." +
                "  If you no longer wish to be considered for this show, " +
                "you may withdraw your bid application." +
                "  If you are confirmed in Hedlyner for another show on the date," +
                " We will automatically withdraw your  bid applications for you" +
                '<br>' +
                '<br>' +
                '<b>' +
                "You also agree to " +
                " <a href=\"/terms-of-service\" class=\"link-purple link-not-styled\" target=\"_blank\">Hedlyner's Terms of Service</a>, " +
                " <a href=\"/payment-terms\" class=\"link-purple link-not-styled\" target=\"_blank\">Payment Terms</a>, " +
                " <a href=\"/refunds-and-cancellation-policy\" class=\"link-purple link-not-styled\" target=\"_blank\">Refunds and Cancellation Policy</a>, " +
                " <a href=\"/dispute-resolution-policy\" class=\"link-purple link-not-styled\" target=\"_blank\">Dispute Resolution Policy</a> and " +
                " <a href=\"/off-platform-policy\" class=\"link-purple link-not-styled\" target=\"_blank\">Off-Platform Policy.</a>" +
                '</b>' + "</div>"
        },

        openBookingPage(bid) {
            window.open('/bookings/' + bid.booking_id + '/artist', '_blank');
        },

        resetExtraInfoBid() {
            removeError()
            this.extraInfoBid = {
                counter_offer: null,
                extra_requirements: null,
            }
        },

        selectFirstList() {
            let vm = this;
            vm.firstList = true;
            vm.secondList = false;
            vm.thirdList = false;
        },

        selectSecondList() {
            let vm = this;
            vm.firstList = false;
            vm.secondList = true;
            vm.thirdList = false;
        },

        selectThirdList() {
            let vm = this;
            vm.firstList = false;
            vm.secondList = false;
            vm.thirdList = true;
        },

        getPhoto() {
            return 'images/user/bid/';
        },

        getChildrenStatus(status) {
            let text = ''
            switch (status) {
                case 0:
                    text = 'Apply';
                    break;
                case 1:
                    text = 'Ignore';
                    break;
                case 2:
                    text = 'Ignore';
                    break;
                default:
                    text = 'Selected';
                    break;
            }
            return text
        },

        getStatus(status) {
            let text = ''
            switch (status) {
                case 0:
                    text = 'In process';
                    break;
                case 1:
                    text = 'Ready to choose';
                    break;
                case 2:
                    text = 'Wait You Approve';
                    break;
                case 3:
                    text = 'Confirmed';
                    break;
                case 4:
                    text = 'Completed';
                    break;
                case 5:
                    text = 'Canceled';
                    break;
                default:
                    text = 'Rejected';
                    break;
            }
            return text
        },
        updateWidth() {
            this.width = window.innerWidth;
        }
    },
    computed: {
        sortProgressBids () {
            return this.bids.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        },
        sortconfirmedAndCompletedBids () {
            return this.confirmedBids.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        },
        sortcancelBids () {
            return this.bookingBids.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        }
    },
    created() {
        window.addEventListener('resize', this.updateWidth)
    },
}

function addError(el) {
    $(el).addClass('cursor-not-allowed').parent().parent().prev().find('.form-input-border').addClass('is-invalid')
        .next().find('strong').text('Please enter a value greater than or equal to ' + minimalPrice)
}

function removeError(el) {
    if (el) {
        $(el).removeClass('cursor-not-allowed').parent().parent().prev().find('.form-input-border').removeClass('is-invalid')
            .next().find('strong').text('')
    } else {
        $('.is-invalid').removeClass('is-invalid')
    }

}

</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    @media (max-width: 1200px) {
        .tab-title {
            flex: 50%;
            padding-top: 20px;
        }
    }

    .wrapper-keywords-pills::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 1200px) {
        .modile-view {
            min-width: 165px;
        }
    }
</style>
